module.exports = __webpack_public_path__ + "static/media/product-DigitalCredit.a03d670f.png";